"use client";

export const NotFoundPage = () => {
  return (
    <main className="flex min-h-svh flex-1 items-center justify-center p-8">
      <div className="text-center">
        <p className="text-6xl font-semibold tracking-tight">404</p>
        <h1 className="mt-4 text-2xl font-semibold">Page not found</h1>
        <p className="mt-2 text-muted-foreground">The page you’re looking for doesn’t exist.</p>
      </div>
    </main>
  );
};
